(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestsellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.bestsellers').forEach(function (section) {
    var rail = section.querySelector('[data-bs-rail]');
    var nav = section.querySelector('[data-bs-nav]');
    var prevBtn = section.querySelector('[data-bs-prev]');
    var nextBtn = section.querySelector('[data-bs-next]');
    if (!rail || !nav || !prevBtn || !nextBtn) return;

    var track = rail.querySelector('.bestsellers__track');
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = prefersReducedMotion ? 'auto' : 'smooth';

    function getStep() {
      var cell = rail.querySelector('.bestsellers__cell');
      if (!cell) return rail.clientWidth * 0.8;
      var rect = cell.getBoundingClientRect();
      return rect.width + 16;
    }

    function scrollByDir(dir) {
      var step = getStep() * 2;
      rail.scrollBy({ left: dir * step, behavior: behavior });
    }

    function updateNavState() {
      // Measure the TRACK's scrollWidth (real content), not the rail's.
      // The rail's scrollWidth includes its own padding-left (used to align
      // the first card with the page container), which inflates the value
      // and breaks the "fits" check. The track is invariant to padding
      // changes, so this measurement is also safe against ResizeObserver loops
      // when toggling the --centered modifier (which changes padding-left).
      var contentWidth = track ? track.scrollWidth : rail.scrollWidth;
      var fits = contentWidth <= rail.clientWidth + 1;
      nav.hidden = fits;
      // Center cards when they all fit; restore left-aligned scroll layout otherwise.
      // toggle() with a boolean force is idempotent — won't loop with ResizeObserver.
      rail.classList.toggle('bestsellers__rail--centered', fits);
      if (fits) return;
      var atStart = rail.scrollLeft <= 1;
      var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    prevBtn.addEventListener('click', function () { scrollByDir(-1); });
    nextBtn.addEventListener('click', function () { scrollByDir(1); });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateNavState();
        ticking = false;
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateNavState, 150);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateNavState).observe(rail);
    }

    updateNavState();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.category-section').forEach(function (section) {
    var rail = section.querySelector('[data-cs-rail]');
    var nav = section.querySelector('[data-cs-nav]');
    var prevBtn = section.querySelector('[data-cs-prev]');
    var nextBtn = section.querySelector('[data-cs-next]');
    if (!rail || !nav || !prevBtn || !nextBtn) return;

    var track = rail.querySelector('.category-section__track');
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = prefersReducedMotion ? 'auto' : 'smooth';

    function getStep() {
      var cell = rail.querySelector('.category-section__cell');
      if (!cell) return rail.clientWidth * 0.8;
      var rect = cell.getBoundingClientRect();
      return rect.width + 16;
    }

    function scrollByDir(dir) {
      var step = getStep() * 2;
      rail.scrollBy({ left: dir * step, behavior: behavior });
    }

    function updateNavState() {
      // Measure track.scrollWidth (real content), not rail.scrollWidth
      // which includes the rail's padding-left used for container alignment
      // and would inflate the value, breaking the fits check.
      // Track is invariant to padding changes — safe against ResizeObserver loops.
      var contentWidth = track ? track.scrollWidth : rail.scrollWidth;
      var fits = contentWidth <= rail.clientWidth + 1;
      nav.hidden = fits;
      // Center cards when they all fit; restore left-aligned scroll otherwise.
      // toggle() with a boolean force is idempotent.
      rail.classList.toggle('category-section__rail--centered', fits);
      if (fits) return;
      var atStart = rail.scrollLeft <= 1;
      var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    prevBtn.addEventListener('click', function () { scrollByDir(-1); });
    nextBtn.addEventListener('click', function () { scrollByDir(1); });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateNavState();
        ticking = false;
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateNavState, 150);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateNavState).observe(rail);
    }

    updateNavState();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.lp-main-contact__form').forEach(function (form) {
      var honeypot = form.querySelector('input[name="contact[website]"]');
      if (!honeypot) return;
      form.addEventListener('submit', function (e) {
        if (honeypot.value.trim() !== '') {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    });

    // Cloudflare Turnstile success callback (invoked when the captcha resolves).
    window.lpContactTurnstileSuccess = function () {
      document.querySelectorAll('.lp-main-contact__submit').forEach(function (btn) {
        btn.disabled = false;
      });
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var BREAKPOINT = 720;

  function syncDetails() {
    var isDesktop = window.innerWidth >= BREAKPOINT;
    document.querySelectorAll('.lp-footer').forEach(function (section) {
      section.querySelectorAll('[data-footer-accordion]').forEach(function (d) {
        if (isDesktop) {
          d.setAttribute('open', '');
        } else {
          d.removeAttribute('open');
        }
      });
    });
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncDetails, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDetails);
  } else {
    syncDetails();
  }
  window.addEventListener('resize', onResize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  // Track active search instances + overlays across all header sections so we
  // can attach document-level listeners (mousedown outside-close + Escape) once
  // at IIFE scope. Re-runs of this script (e.g. theme editor re-render) replace
  // the registry, preventing duplicate listeners from leaking.
  if (window.__lpHeaderSearchTeardown) {
    try { window.__lpHeaderSearchTeardown(); } catch (e) {}
  }
  var lpSearchInstances = [];
  var lpSearchOverlays = [];
  var lpDrawers = [];

  function lpOutsideMousedown(e) {
    lpSearchInstances.forEach(function(inst) {
      if (!inst || !inst.isOpen()) return;
      if (!inst.root.contains(e.target)) inst.close();
    });
  }
  function lpDocEscape(e) {
    if (e.key !== 'Escape') return;
    lpSearchOverlays.forEach(function(overlay) {
      if (overlay && !overlay.el.hasAttribute('hidden')) overlay.close();
    });
    lpDrawers.forEach(function(d) {
      if (d && d.el && d.el.getAttribute('aria-hidden') === 'false') d.close();
    });
  }
  document.addEventListener('mousedown', lpOutsideMousedown);
  document.addEventListener('keydown', lpDocEscape);
  window.__lpHeaderSearchTeardown = function() {
    document.removeEventListener('mousedown', lpOutsideMousedown);
    document.removeEventListener('keydown', lpDocEscape);
    lpSearchInstances.length = 0;
    lpSearchOverlays.length = 0;
    lpDrawers.length = 0;
  };

  document.querySelectorAll('.lp-header').forEach(function(section) {
    var drawer = section.querySelector('.lp-header__drawer');

    function openDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      document.body.style.overflow = '';
    }

    section.querySelectorAll('[data-drawer-open]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });

    section.querySelectorAll('[data-drawer-close]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    if (drawer) {
      lpDrawers.push({ el: drawer, close: closeDrawer });
    }

    section.querySelectorAll('[data-cart-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          e.preventDefault();
          cartDrawer.open();
        }
      });
    });

    /* ── Predictive search ─────────────────────────────── */

    var RECENT_KEY = 'lp_recent_searches';
    var SEARCH_DEBOUNCE = 200;
    var SEARCH_LIMIT = 4;

    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function(c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function highlight(text, q) {
      var safe = escapeHtml(text);
      if (!q) return safe;
      var qEsc = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      try {
        return safe.replace(new RegExp('(' + qEsc + ')', 'ig'),
          '<mark class="lp-header__search-hl">$1</mark>');
      } catch (err) {
        return safe;
      }
    }

    function formatMoney(value) {
      if (value == null || value === '') return '';
      // /search/suggest.json returns `price` as a pre-formatted DECIMAL STRING
      // in major units (e.g. "26518.50"), while `price_min` / `compare_at_price_min`
      // come as integers in cents (e.g. 2651850). We must normalize both shapes
      // to a major-unit Number before formatting — and never pass a raw decimal
      // string back to the user, since '26518.50' has no $ or thousands separator.
      var major;
      if (typeof value === 'string') {
        var trimmed = value.trim();
        // Already fully formatted by Shopify (contains $ or a thousands separator
        // like '$1.000,00' or '$1,000.00') — pass through untouched.
        if (/^\$/.test(trimmed) || /[.,]\d{3}([.,]|$)/.test(trimmed)) {
          return trimmed;
        }
        // Bare decimal string from suggest.json — this IS major units already.
        if (trimmed.indexOf('.') !== -1 || trimmed.indexOf(',') !== -1) {
          major = parseFloat(trimmed.replace(',', '.'));
          if (isNaN(major)) return trimmed;
        } else {
          // Pure integer string — treat as cents.
          var asInt = Number(trimmed);
          if (isNaN(asInt)) return trimmed;
          major = asInt / 100;
        }
      } else if (typeof value === 'number') {
        // Numeric value from the API — Shopify returns these in cents.
        major = value / 100;
      } else {
        return '';
      }
      try {
        return '$' + major.toLocaleString('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch (err) {
        return '$' + major.toFixed(2);
      }
    }

    function lpSearchUid(prefix) {
      var rand;
      try {
        rand = (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) || '';
      } catch (e) { rand = ''; }
      if (!rand) rand = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      return prefix + '-' + rand;
    }

    function readRecents() {
      try {
        var raw = localStorage.getItem(RECENT_KEY);
        if (!raw) return [];
        var arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch (err) {
        return [];
      }
    }

    function writeRecents(arr) {
      try {
        localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, 5)));
      } catch (err) {}
    }

    function pushRecent(q) {
      q = (q || '').trim();
      if (!q) return;
      var arr = readRecents().filter(function(t) {
        return t.toLowerCase() !== q.toLowerCase();
      });
      arr.unshift(q);
      writeRecents(arr);
    }

    function buildSuggestUrl(q) {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (base.charAt(base.length - 1) !== '/') base += '/';
      // limit_scope=each makes the SEARCH_LIMIT apply PER resource type
      // (4 products + 4 queries + 4 collections), instead of the default
      // last-scope behavior which uses limit as a single cross-type cap
      // (where products often lose slots to queries/collections and only
      // 1-2 products show even when many match).
      return base + 'search/suggest.json?q=' + encodeURIComponent(q) +
             '&resources[type]=product,query,collection' +
             '&resources[limit]=' + SEARCH_LIMIT +
             '&resources[limit_scope]=each' +
             '&resources[options][unavailable_products]=last';
    }

    function buildSearchUrl(q) {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (base.charAt(base.length - 1) !== '/') base += '/';
      return base + 'search?q=' + encodeURIComponent(q) + '&type=product';
    }

    function renderProducts(list, products, q) {
      if (!list) return 0;
      list.innerHTML = '';
      if (!products || !products.length) return 0;
      products.forEach(function(p, i) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'lp-header__search-product';
        a.href = p.url || '#';
        a.setAttribute('data-lp-search-product', '');
        a.setAttribute('role', 'option');
        a.id = lpSearchUid('lp-search-opt');

        var thumb = (p.featured_image && (p.featured_image.url || p.image)) || p.image || '';
        // Resolve raw price (variant.price or price_min). predictive_search.json
        // returns price in cents-as-number for shops with cent-major currencies.
        var rawPrice = (p.price != null) ? p.price : (p.price_min != null ? p.price_min : null);
        var numericPrice = parseFloat(rawPrice);
        // Treat zero / null / missing as a quote-only product (e.g.
        // lp_pricing.quote_only) and surface 'Precio a consultar' instead of
        // '$0,00'. The predictive_search.json endpoint does not return
        // metafields, so price==0 is the only signal we have client-side.
        var isQuoteOnly = (rawPrice == null) || (!isNaN(numericPrice) && numericPrice === 0);
        var price = '';
        if (!isQuoteOnly && rawPrice != null) {
          price = formatMoney(rawPrice);
        }
        var compare = '';
        if (!isQuoteOnly && p.compare_at_price_min != null && p.price_min != null && p.compare_at_price_min > p.price_min) {
          compare = formatMoney(p.compare_at_price_min);
        }
        var quoteLabel = '';
        if (isQuoteOnly) {
          var i18nHost = list.closest('[data-search-root], [data-search-overlay]');
          quoteLabel = (i18nHost && i18nHost.getAttribute('data-i18n-priceconsult')) || 'Precio a consultar';
        }
        var category = '';
        if (p.product_type) category = p.product_type;
        else if (p.vendor) category = p.vendor;

        var thumbHtml = thumb
          ? '<img class="lp-header__search-product-thumb" src="' + escapeHtml(thumb) + '" alt="" loading="lazy" />'
          : '<span class="lp-header__search-product-thumb" aria-hidden="true"></span>';

        var trailHtml = '';
        if (isQuoteOnly) {
          trailHtml = '<span class="lp-header__search-product-price lp-header__search-product-price--quote">' + escapeHtml(quoteLabel) + '</span>';
        } else if (price) {
          trailHtml = '<span class="lp-header__search-product-price">' +
            '<span>' + price + '</span>' +
            (compare ? '<span class="lp-header__search-product-price--compare">' + compare + '</span>' : '') +
            '</span>';
        }

        a.innerHTML =
          thumbHtml +
          '<span class="lp-header__search-product-body">' +
            '<span class="lp-header__search-product-title">' + highlight(p.title || '', q) + '</span>' +
            (category ? '<span class="lp-header__search-product-cat">' + escapeHtml(category) + '</span>' : '') +
          '</span>' +
          trailHtml;

        li.appendChild(a);
        list.appendChild(li);
      });
      return products.length;
    }

    function renderTerms(list, terms, q) {
      if (!list) return 0;
      list.innerHTML = '';
      if (!terms || !terms.length) return 0;
      terms.forEach(function(t, i) {
        var label = t.styled_text || t.text || '';
        var raw = t.text || label.replace(/<[^>]+>/g, '');
        var href = buildSearchUrl(raw);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'lp-header__search-term';
        a.href = href;
        a.setAttribute('data-lp-search-term', '');
        a.setAttribute('role', 'option');
        a.id = lpSearchUid('lp-search-opt');
        a.innerHTML =
          '<span class="lp-header__search-term-icon">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>' +
          '</span>' +
          '<span class="lp-header__search-term-label">' + (t.styled_text ? t.styled_text : highlight(raw, q)) + '</span>';
        li.appendChild(a);
        list.appendChild(li);
      });
      return terms.length;
    }

    function renderCats(container, cats, q) {
      if (!container) return 0;
      container.innerHTML = '';
      if (!cats || !cats.length) return 0;
      cats.forEach(function(c, i) {
        var a = document.createElement('a');
        a.className = 'lp-header__search-cat';
        a.href = c.url || '#';
        a.setAttribute('data-search-cat', '');
        a.setAttribute('role', 'option');
        a.id = lpSearchUid('lp-search-opt');
        a.innerHTML =
          '<span class="lp-header__search-cat-label">' + highlight(c.title || '', q) + '</span>' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
        container.appendChild(a);
      });
      return cats.length;
    }

    function initSearchInstance(root, opts) {
      opts = opts || {};
      if (!root) return null;
      var input = opts.input || root.querySelector('.lp-header__search-input');
      var form = opts.form || root.querySelector('form');
      var clearBtn = opts.clear || root.querySelector('.lp-header__search-clear');
      var dropdown = opts.dropdown || root.querySelector('.lp-header__search-dropdown');
      var pEmpty = opts.empty || root.querySelector('[data-search-panel="empty"]');
      var pResults = opts.results || root.querySelector('[data-search-panel="results"]');
      var pNo = opts.noresults || root.querySelector('[data-search-panel="no-results"]');

      var state = { q: '', open: false, activeIndex: -1, abort: null, timer: null };
      var lastProducts = [];

      function showPanel(name) {
        if (pEmpty) pEmpty.classList.toggle('is-hidden', name !== 'empty');
        if (pResults) pResults.classList.toggle('is-hidden', name !== 'results');
        if (pNo) pNo.classList.toggle('is-hidden', name !== 'no-results');
      }

      function openDropdown() {
        if (!dropdown) return;
        dropdown.removeAttribute('hidden');
        root.classList.add('is-open');
        if (input) input.setAttribute('aria-expanded', 'true');
        state.open = true;
      }

      function closeDropdown() {
        if (!dropdown) return;
        dropdown.setAttribute('hidden', '');
        root.classList.remove('is-open');
        if (input) input.setAttribute('aria-expanded', 'false');
        state.open = false;
        state.activeIndex = -1;
      }

      function setClearVisible(v) {
        if (!clearBtn) return;
        if (v) {
          clearBtn.removeAttribute('hidden');
          clearBtn.classList.add('is-visible');
        } else {
          clearBtn.setAttribute('hidden', '');
          clearBtn.classList.remove('is-visible');
        }
      }

      function getActiveRows() {
        if (!pResults) return [];
        return Array.prototype.slice.call(
          pResults.querySelectorAll('[data-lp-search-product], [data-lp-search-term], [data-search-cat]')
        );
      }

      function updateActive() {
        var rows = getActiveRows();
        rows.forEach(function(r, i) {
          r.classList.toggle('is-active', i === state.activeIndex);
        });
        if (input) {
          var current = rows[state.activeIndex];
          if (state.activeIndex >= 0 && current && current.id) {
            input.setAttribute('aria-activedescendant', current.id);
          } else {
            input.removeAttribute('aria-activedescendant');
          }
        }
      }

      function sortByQueryMatch(products, q) {
        if (!q || !products || !products.length) return products || [];
        var lq = q.toLowerCase().trim();
        return products.slice().sort(function(a, b) {
          var at = (a.title || '').toLowerCase();
          var bt = (b.title || '').toLowerCase();
          // Score: 0 = title starts with q (best), 1 = first word starts with q, 2 = anywhere, 3 = no match
          function score(t) {
            if (t.indexOf(lq) === 0) return 0;
            var firstWord = t.split(/\s+/)[0] || '';
            if (firstWord.indexOf(lq) === 0) return 1;
            if (t.indexOf(lq) !== -1) return 2;
            return 3;
          }
          var sa = score(at), sb = score(bt);
          if (sa !== sb) return sa - sb;
          // Tie-breaker: shorter title first (more specific match)
          return at.length - bt.length;
        });
      }

      function fetchSuggestions(q) {
        if (state.abort) state.abort.abort();
        state.abort = new AbortController();
        var url = buildSuggestUrl(q);
        fetch(url, { signal: state.abort.signal, headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var res = (data && data.resources && data.resources.results) || {};
            var products = res.products || [];
            var queries = res.queries || [];
            var collections = res.collections || [];
            products = sortByQueryMatch(products, q);
            lastProducts = products;

            var termsSlot = pResults && pResults.querySelector('[data-slot="terms"]');
            var termsList = termsSlot && termsSlot.querySelector('[data-slot-list]');
            var catsSlot = pResults && pResults.querySelector('[data-slot="cats"]');
            var catsList = catsSlot && catsSlot.querySelector('[data-slot-list]');
            var prodSlot = pResults && pResults.querySelector('[data-slot="products"]');
            var prodList = prodSlot && prodSlot.querySelector('[data-slot-list]');
            var seeAllSlot = pResults && pResults.querySelector('[data-slot="seeall"]');
            var seeAllLink = seeAllSlot && seeAllSlot.querySelector('[data-search-see-all]');
            var seeAllLabel = seeAllSlot && seeAllSlot.querySelector('[data-see-all-label]');

            var nTerms = renderTerms(termsList, queries, q);
            var nCats = renderCats(catsList, collections, q);
            var nProds = renderProducts(prodList, products, q);

            if (termsSlot) termsSlot.toggleAttribute('hidden', nTerms === 0);
            if (catsSlot) catsSlot.toggleAttribute('hidden', nCats === 0);
            if (prodSlot) prodSlot.toggleAttribute('hidden', nProds === 0);

            if (nTerms + nCats + nProds === 0) {
              if (pNo) {
                var lbl = pNo.querySelector('[data-noresults-label]');
                var tmpl = root.getAttribute('data-i18n-noresults') || 'No results for __Q__';
                if (lbl) lbl.textContent = tmpl.replace('__Q__', q);
              }
              showPanel('no-results');
            } else {
              if (seeAllSlot) {
                seeAllSlot.removeAttribute('hidden');
                if (seeAllLink) seeAllLink.href = buildSearchUrl(q);
                if (seeAllLabel) {
                  var tmpl2 = root.getAttribute('data-i18n-seeall') || 'See all results for __Q__';
                  seeAllLabel.textContent = tmpl2.replace('__Q__', q);
                }
              }
              showPanel('results');
            }
            state.activeIndex = -1;
            updateActive();
          })
          .catch(function(err) {
            if (err && err.name === 'AbortError') return;
          });
      }

      function handleInput() {
        var q = (input && input.value || '').trim();
        state.q = q;
        setClearVisible(q.length > 0);
        if (!q) {
          if (state.timer) { clearTimeout(state.timer); state.timer = null; }
          if (state.abort) { try { state.abort.abort(); } catch (e) {} state.abort = null; }
          showPanel('empty');
          openDropdown();
          return;
        }
        if (state.timer) clearTimeout(state.timer);
        state.timer = setTimeout(function() {
          fetchSuggestions(q);
        }, SEARCH_DEBOUNCE);
        openDropdown();
      }

      if (input) {
        input.addEventListener('input', handleInput);
        input.addEventListener('focus', function() {
          openDropdown();
          if (!state.q) showPanel('empty');
        });
        input.addEventListener('keydown', function(e) {
          var rows = getActiveRows();
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!state.open) openDropdown();
            state.activeIndex = Math.min(state.activeIndex + 1, rows.length - 1);
            updateActive();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            state.activeIndex = Math.max(state.activeIndex - 1, -1);
            updateActive();
          } else if (e.key === 'Enter') {
            if (state.activeIndex >= 0 && rows[state.activeIndex]) {
              e.preventDefault();
              var href = rows[state.activeIndex].getAttribute('href');
              if (href) {
                pushRecent(state.q);
                window.location.href = href;
              }
            } else {
              pushRecent(state.q);
            }
          } else if (e.key === 'Escape') {
            closeDropdown();
            input.blur();
          }
        });
      }

      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          if (input) {
            input.value = '';
            input.focus();
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
          setClearVisible(false);
          showPanel('empty');
        });
      }

      if (pResults) {
        pResults.addEventListener('mouseover', function(e) {
          var row = e.target.closest('[data-lp-search-product], [data-lp-search-term], [data-search-cat]');
          if (!row) return;
          var rows = getActiveRows();
          state.activeIndex = rows.indexOf(row);
          updateActive();
        });
      }

      if (form) {
        form.addEventListener('submit', function() {
          pushRecent(state.q);
        });
      }

      var instance = {
        root: root,
        open: openDropdown,
        close: closeDropdown,
        isOpen: function() { return !!state.open; },
        setQuery: function(q) {
          if (!input) return;
          input.value = q;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        }
      };
      lpSearchInstances.push(instance);
      return instance;
    }

    /* Desktop dropdown */
    var desktopRoot = section.querySelector('[data-search-root]');
    if (desktopRoot) initSearchInstance(desktopRoot);

    /* Mobile overlay */
    var overlay = section.querySelector('[data-search-overlay]');
    var trigger = section.querySelector('[data-search-mobile-trigger]');
    var overlayInput = overlay && overlay.querySelector('[data-search-overlay-input]');
    var overlayForm = overlay && overlay.querySelector('[data-search-overlay-form]');
    var overlayClear = overlay && overlay.querySelector('[data-search-overlay-clear]');
    var overlayBack = overlay && overlay.querySelector('[data-search-overlay-close]');
    var overlayResults = overlay && overlay.querySelector('[data-search-overlay-results]');
    var overlayNo = overlay && overlay.querySelector('[data-search-overlay-noresults]');
    var overlayRecent = overlay && overlay.querySelector('[data-search-overlay-recent]');
    var overlayRecentList = overlay && overlay.querySelector('[data-search-overlay-recent-list]');
    var overlayClearRecent = overlay && overlay.querySelector('[data-search-clear-recent]');

    function renderRecents() {
      if (!overlayRecentList || !overlayRecent) return;
      var arr = readRecents();
      overlayRecentList.innerHTML = '';
      if (!arr.length) {
        overlayRecent.setAttribute('hidden', '');
        return;
      }
      overlayRecent.removeAttribute('hidden');
      arr.forEach(function(t) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'lp-header__search-term';
        a.href = buildSearchUrl(t);
        a.innerHTML =
          '<span class="lp-header__search-term-icon">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>' +
          '</span>' +
          '<span class="lp-header__search-term-label">' + escapeHtml(t) + '</span>';
        li.appendChild(a);
        overlayRecentList.appendChild(li);
      });
    }

    function openOverlay() {
      if (!overlay) return;
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('lp-header--search-open');
      renderRecents();
      setTimeout(function() {
        if (overlayInput) overlayInput.focus();
      }, 50);
    }

    function closeOverlay() {
      if (!overlay) return;
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.body.classList.remove('lp-header--search-open');
    }

    if (trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openOverlay();
      });
    }

    if (overlayBack) {
      overlayBack.addEventListener('click', function(e) {
        e.preventDefault();
        closeOverlay();
      });
    }

    /* Tap/click en el backdrop dim (el area debajo del panel) cierra.
       Solo cuando el target es el overlay mismo: los hijos (bar/body)
       siguen interactuables. */
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeOverlay();
      });
    }

    if (overlay) {
      lpSearchOverlays.push({ el: overlay, close: closeOverlay });
    }

    if (overlay) {
      /* Lightweight predictive search for the overlay */
      var oTimer = null;
      var oAbort = null;
      function overlayShowPanel(name) {
        if (overlayResults) overlayResults.classList.toggle('is-hidden', name !== 'results');
        if (overlayNo) overlayNo.classList.toggle('is-hidden', name !== 'no-results');
        if (overlayInput) {
          overlayInput.setAttribute('aria-expanded', name === 'results' || name === 'no-results' ? 'true' : 'false');
        }
      }
      function overlayFetch(q) {
        if (oAbort) oAbort.abort();
        oAbort = new AbortController();
        fetch(buildSuggestUrl(q), { signal: oAbort.signal, headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var res = (data && data.resources && data.resources.results) || {};
            var products = res.products || [];
            var queries = res.queries || [];
            // Mirror desktop: sort products so first-word matches outrank
            // anywhere-matches (so "calef" surfaces "Calefactor A9" before
            // "Kit de Instalación de PARED para Calefactor...").
            products = sortByQueryMatch(products, q);

            var termsSlot = overlayResults && overlayResults.querySelector('[data-slot="terms"]');
            var termsList = termsSlot && termsSlot.querySelector('[data-slot-list]');
            var prodSlot = overlayResults && overlayResults.querySelector('[data-slot="products"]');
            var prodList = prodSlot && prodSlot.querySelector('[data-slot-list]');
            var seeAllSlot = overlayResults && overlayResults.querySelector('[data-slot="seeall"]');
            var seeAllLink = seeAllSlot && seeAllSlot.querySelector('[data-search-see-all]');
            var seeAllLabel = seeAllSlot && seeAllSlot.querySelector('[data-see-all-label]');

            var nT = renderTerms(termsList, queries, q);
            var nP = renderProducts(prodList, products, q);
            if (termsSlot) termsSlot.toggleAttribute('hidden', nT === 0);
            if (prodSlot) prodSlot.toggleAttribute('hidden', nP === 0);

            if (nT + nP === 0) {
              if (overlayNo) {
                var lbl = overlayNo.querySelector('[data-noresults-label]');
                var tmpl = overlay.getAttribute('data-i18n-noresults') || 'No results for __Q__';
                if (lbl) lbl.textContent = tmpl.replace('__Q__', q);
              }
              overlayShowPanel('no-results');
            } else {
              if (seeAllSlot) {
                seeAllSlot.removeAttribute('hidden');
                if (seeAllLink) seeAllLink.href = buildSearchUrl(q);
                if (seeAllLabel) {
                  var tmpl2 = overlay.getAttribute('data-i18n-seeall') || 'See all results for __Q__';
                  seeAllLabel.textContent = tmpl2.replace('__Q__', q);
                }
              }
              overlayShowPanel('results');
            }
          })
          .catch(function(err) {
            if (err && err.name === 'AbortError') return;
          });
      }

      if (overlayInput) {
        overlayInput.addEventListener('input', function() {
          var q = overlayInput.value.trim();
          if (overlayClear) {
            if (q) overlayClear.removeAttribute('hidden');
            else overlayClear.setAttribute('hidden', '');
          }
          if (!q) {
            if (oTimer) { clearTimeout(oTimer); oTimer = null; }
            if (oAbort) { try { oAbort.abort(); } catch (e) {} oAbort = null; }
            if (overlayResults) overlayResults.classList.add('is-hidden');
            if (overlayNo) overlayNo.classList.add('is-hidden');
            overlayInput.setAttribute('aria-expanded', 'false');
            return;
          }
          if (oTimer) clearTimeout(oTimer);
          oTimer = setTimeout(function() { overlayFetch(q); }, SEARCH_DEBOUNCE);
        });
      }

      if (overlayClear) {
        overlayClear.addEventListener('click', function() {
          if (overlayInput) {
            overlayInput.value = '';
            overlayInput.dispatchEvent(new Event('input', { bubbles: true }));
            overlayInput.focus();
          }
        });
      }

      if (overlayForm) {
        overlayForm.addEventListener('submit', function() {
          if (overlayInput) pushRecent(overlayInput.value);
        });
      }

      if (overlayClearRecent) {
        overlayClearRecent.addEventListener('click', function() {
          writeRecents([]);
          renderRecents();
        });
      }

      /* Chip click logs recent (the anchor still navigates) */
      overlay.querySelectorAll('[data-search-chip]').forEach(function(chip) {
        chip.addEventListener('click', function() {
          pushRecent(chip.getAttribute('data-search-chip'));
        });
      });
    }
  });
})();

/* ──────────────────────────────────────────────────────────────
   Megamenu controller — hover continuo + animacion + teclado.
   - Hover continuo: al pasar de un menu con panel a otro, el panel
     NO se cierra (gracia de 160ms cubre el espacio entre items) y el
     contenido cambia sin replay de animacion (clase --instant).
   - Primera apertura: anima (opacity + translateY, ver CSS).
   - Teclado: focusin abre el panel (los links internos se vuelven
     alcanzables por Tab), focusout fuera del item lo cierra, Escape
     cierra y devuelve el foco al link padre.
   El CSS trae fallback :hover/:focus-within que solo aplica si esta
   clase --js no se agrego (JS deshabilitado).
   ────────────────────────────────────────────────────────────── */
(function () {
  var nav = document.querySelector('.lp-header__nav');
  if (!nav) return;
  nav.classList.add('lp-header__nav--js');

  var items = Array.prototype.slice.call(nav.querySelectorAll('.lp-header__nav-item--mega'));
  if (!items.length) return;

  var current = null;
  var closeTimer = null;

  function panelOf(item) {
    return item.querySelector('.lp-header__megamenu');
  }

  function instant(panel) {
    if (!panel) return;
    panel.classList.add('lp-header__megamenu--instant');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.classList.remove('lp-header__megamenu--instant');
      });
    });
  }

  function open(item) {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (current === item) return;
    if (current) {
      /* Cambio directo entre menus: swap sin animacion en ambos paneles. */
      instant(panelOf(current));
      instant(panelOf(item));
      current.classList.remove('is-open');
    }
    item.classList.add('is-open');
    current = item;
  }

  function closeNow() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (!current) return;
    current.classList.remove('is-open');
    current = null;
  }

  function scheduleClose() {
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(closeNow, 160);
  }

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () { open(item); });
    item.addEventListener('mouseleave', scheduleClose);
    item.addEventListener('focusin', function () { open(item); });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) scheduleClose();
    });
  });

  /* Salir del nav por cualquier lado cierra (con gracia). */
  nav.addEventListener('mouseleave', scheduleClose);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !current) return;
    var trigger = current.querySelector('.lp-header__nav-link');
    closeNow();
    if (trigger) trigger.focus();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.hero[data-hero-autoplay]').forEach(function (section) {
    var autoplayMs = parseInt(section.dataset.heroAutoplay, 10) || 0;
    var total = parseInt(section.dataset.heroTotal, 10) || 0;
    if (total <= 1) return;

    var slides = section.querySelectorAll('[data-hero-slide]');
    var dots = section.querySelectorAll('[data-hero-dot]');
    var idx = 0;
    var userPaused = false;
    /* Pausa manual (boton WCAG 2.2.2): persiste aunque mouseleave/focusout
       disparen resume(); solo el propio boton la levanta. */
    var manualPaused = false;
    var sectionVisible = true;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    section.style.setProperty('--hero-autoplay-ms', autoplayMs + 'ms');

    function canAutoplay() {
      return autoplayMs > 0 && !prefersReducedMotion;
    }

    function isPaused() {
      return userPaused || manualPaused || !sectionVisible;
    }

    function handleProgressEnd() {
      goTo(idx + 1);
    }

    function bindProgressEnd() {
      if (!dots[idx]) return;
      var fill = dots[idx].querySelector('.hero__dot-fill');
      if (!fill) return;
      fill.removeEventListener('animationend', handleProgressEnd);
      fill.addEventListener('animationend', handleProgressEnd, { once: true });
    }

    function goTo(n) {
      slides[idx].setAttribute('aria-hidden', 'true');
      if (dots[idx]) {
        dots[idx].classList.remove('hero__dot--active', 'hero__dot--playing', 'hero__dot--paused');
      }

      idx = ((n % total) + total) % total;

      slides[idx].setAttribute('aria-hidden', 'false');
      if (dots[idx]) {
        var fill = dots[idx].querySelector('.hero__dot-fill');
        if (fill) {
          fill.style.animation = 'none';
          fill.offsetHeight;
          fill.style.animation = '';
        }
        dots[idx].classList.add('hero__dot--active');
        if (canAutoplay()) {
          dots[idx].classList.add('hero__dot--playing');
          if (isPaused()) {
            dots[idx].classList.add('hero__dot--paused');
          }
          bindProgressEnd();
        }
      }
    }

    function pause() {
      userPaused = true;
      if (dots[idx]) {
        dots[idx].classList.add('hero__dot--paused');
      }
    }

    function resume() {
      userPaused = false;
      /* La pausa manual del boton prevalece: mouseleave/focusout no reanudan. */
      if (manualPaused) return;
      if (dots[idx]) {
        dots[idx].classList.remove('hero__dot--paused');
        if (canAutoplay()) {
          bindProgressEnd();
        }
      }
    }

    section.addEventListener('mouseenter', pause);
    section.addEventListener('mouseleave', resume);
    section.addEventListener('focusin', function (e) {
      if (e.target.closest('[data-hero-prev], [data-hero-next], [data-hero-dot], [data-hero-pause]')) return;
      pause();
    });
    section.addEventListener('focusout', function (e) {
      if (e.target.closest('[data-hero-prev], [data-hero-next], [data-hero-dot], [data-hero-pause]')) return;
      resume();
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.heroDot, 10));
      });
    });

    var prevBtn = section.querySelector('[data-hero-prev]');
    var nextBtn = section.querySelector('[data-hero-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(idx - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(idx + 1);
      });
    }

    var pauseBtn = section.querySelector('[data-hero-pause]');
    if (pauseBtn) {
      if (!canAutoplay()) {
        /* Autoplay anulado por prefers-reduced-motion (el setting en 0 ya
           evita el render del boton desde Liquid): sin autoplay no hay nada
           que pausar, ocultamos el control. */
        pauseBtn.hidden = true;
      } else {
        pauseBtn.addEventListener('click', function () {
          manualPaused = !manualPaused;
          pauseBtn.classList.toggle('is-paused', manualPaused);
          if (manualPaused) {
            pauseBtn.setAttribute('aria-label', pauseBtn.dataset.labelPlay);
            if (dots[idx]) dots[idx].classList.add('hero__dot--paused');
          } else {
            pauseBtn.setAttribute('aria-label', pauseBtn.dataset.labelPause);
            /* En touch el tap dispara un mouseenter sintetico que deja
               userPaused en true sin mouseleave posterior; lo limpiamos para
               que el "play" explicito siempre reanude. */
            userPaused = false;
            if (sectionVisible && dots[idx]) {
              dots[idx].classList.remove('hero__dot--paused');
              bindProgressEnd();
            }
          }
        });
      }
    }

    if (canAutoplay() && dots[0]) {
      dots[0].classList.add('hero__dot--playing');
      bindProgressEnd();
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sectionVisible = entry.isIntersecting;
          if (!sectionVisible) {
            if (dots[idx]) dots[idx].classList.add('hero__dot--paused');
          } else if (!userPaused && !manualPaused && canAutoplay()) {
            if (dots[idx]) {
              dots[idx].classList.remove('hero__dot--paused');
              bindProgressEnd();
            }
          }
        });
      }, { threshold: 0.3 });
      observer.observe(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeroSplit(root) {
    if (root._hsInit) return;
    root._hsInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hs-dot]'));
    var total = slides.length;
    if (total <= 1) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0;

    function activeFill() {
      var d = dots[idx];
      return d ? d.querySelector('.hero-split__dot-fill') : null;
    }

    function paint() {
      slides.forEach(function (s, k) {
        var on = k === idx;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === idx);
      });
    }

    /* La barra de progreso es una animacion CSS (transform: scaleX) sobre el
       dot activo: lisa y en GPU, sin saltos de frame. Para relanzarla en cada
       cambio de slide quitamos la animacion inline, forzamos reflow y la
       devolvemos al CSS. El avance automatico lo dispara animationend. */
    function restartProgress() {
      var f = activeFill();
      if (!f) return;
      f.style.animation = 'none';
      void f.offsetWidth;
      f.style.animation = '';
    }

    function go(k) {
      idx = (k + total) % total;
      paint();
      if (!reduce) restartProgress();
    }

    dots.forEach(function (d) {
      var f = d.querySelector('.hero-split__dot-fill');
      if (!f) return;
      f.addEventListener('animationend', function () {
        if (d.classList.contains('is-active')) go(idx + 1);
      });
    });

    function pause() { root.classList.add('is-paused'); }
    function resume() { root.classList.remove('is-paused'); }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k); });
    });
    var prev = root.querySelector('[data-hs-prev]');
    var next = root.querySelector('[data-hs-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });

    /* Pausar SOLO al pasar por la tarjeta-slideshow, no por toda la fila:
       antes los listeners estaban en la seccion entera, asi que el hover
       sobre los promo tiles (o el espacio al costado) tambien la frenaba. */
    var showCard = root.querySelector('.hero-split__show') || root;
    showCard.addEventListener('mouseenter', pause);
    showCard.addEventListener('mouseleave', resume);
    showCard.addEventListener('focusin', pause);
    showCard.addEventListener('focusout', resume);

    paint();
    if (!reduce) restartProgress();

    /* Anti-anti-patron de carrusel: el autoplay se retiene (clase --hold en
       el render) para que durante la ventana de medicion del LCP el hero
       quede fijo en el primer slide (su imagen es el verdadero LCP). Lo
       soltamos recien tras 'load' + un margen, cuando el LCP ya esta
       congelado. En reduced-motion no hay autoplay, asi que quitamos el
       hold de inmediato para no dejar clases muertas. */
    function releaseHold() {
      if (!root.classList.contains('hero-split--hold')) return;
      root.classList.remove('hero-split--hold');
      if (!reduce) restartProgress();
    }
    if (reduce) {
      root.classList.remove('hero-split--hold');
    } else if (document.readyState === 'complete') {
      setTimeout(releaseHold, 3000);
    } else {
      window.addEventListener('load', function () {
        setTimeout(releaseHold, 3000);
      }, { once: true });
    }
  }

  function boot() {
    document.querySelectorAll('[data-hero-split]').forEach(initHeroSplit);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-campaign-banner-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseEnd(value) {
    if (!value) return null;
    var v = String(value).trim();
    if (v.indexOf('T') === -1 && v.indexOf(' ') !== -1) {
      v = v.replace(' ', 'T');
    }
    var d = new Date(v);
    if (isNaN(d.getTime())) return null;
    return d;
  }

  function init(root) {
    var endAt = parseEnd(root.getAttribute('data-end-at'));
    if (!endAt) return;

    var section = root.closest('.lp-campaign-banner-rail');
    var nums = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };

    var timerId = null;
    var endedDispatched = false;

    function tick() {
      var now = new Date();
      var diff = Math.max(0, Math.floor((endAt.getTime() - now.getTime()) / 1000));
      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;

      if (nums.days) nums.days.textContent = pad(d);
      if (nums.hours) nums.hours.textContent = pad(h);
      if (nums.minutes) nums.minutes.textContent = pad(m);
      if (nums.seconds) nums.seconds.textContent = pad(s);

      if (diff <= 0 && !endedDispatched) {
        endedDispatched = true;
        if (timerId) clearInterval(timerId);
        if (section) section.classList.add('lp-campaign-banner-rail--ended');
        root.dispatchEvent(new CustomEvent('lp-countdown:ended', { bubbles: true }));
      }
    }

    timerId = setInterval(tick, 1000);
    tick();
  }

  function bootAll(scope) {
    (scope || document).querySelectorAll('.lp-campaign-banner-rail [data-lp-countdown]').forEach(function(el){
      if (el.dataset.lpCountdownInit === '1') return;
      el.dataset.lpCountdownInit = '1';
      init(el);
    });
  }
  bootAll();
  document.addEventListener('shopify:section:load', function(e){ bootAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-campaign-dealgrid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    n = Math.max(0, Math.floor(n));
    return n < 10 ? '0' + n : '' + n;
  }

  function initCountdown(el) {
    if (el.dataset.lpCountdownReady === '1') return;
    var endTs = parseInt(el.getAttribute('data-end'), 10);
    if (!endTs || isNaN(endTs)) return;
    el.dataset.lpCountdownReady = '1';

    var endMs = endTs * 1000;

    var digits = {};
    el.querySelectorAll('.lp-campaign-dealgrid__timer-digit').forEach(function (d) {
      var key = d.getAttribute('data-key');
      if (key) digits[key] = d;
    });

    var section = el.closest('.lp-campaign-dealgrid');
    var ended = false;
    var intervalId = null;

    function tick() {
      var nowMs = Date.now();
      var diff = Math.max(0, endMs - nowMs);

      if (diff <= 0 && !ended) {
        ended = true;
        if (digits.days) digits.days.textContent = '00';
        if (digits.hours) digits.hours.textContent = '00';
        if (digits.minutes) digits.minutes.textContent = '00';
        if (digits.seconds) digits.seconds.textContent = '00';
        if (intervalId) clearInterval(intervalId);
        if (section) {
          section.classList.add('lp-campaign-dealgrid--ended');
          section.dispatchEvent(new CustomEvent('lp-countdown:ended', { bubbles: true }));
        }
        return;
      }

      var totalSec = Math.floor(diff / 1000);
      var days = Math.floor(totalSec / 86400);
      var hours = Math.floor((totalSec % 86400) / 3600);
      var minutes = Math.floor((totalSec % 3600) / 60);
      var seconds = totalSec % 60;

      if (digits.days) digits.days.textContent = pad(days);
      if (digits.hours) digits.hours.textContent = pad(hours);
      if (digits.minutes) digits.minutes.textContent = pad(minutes);
      if (digits.seconds) digits.seconds.textContent = pad(seconds);
    }

    tick();
    intervalId = setInterval(tick, 1000);
  }

  function bootDealgrid(scope) {
    (scope || document).querySelectorAll('.lp-campaign-dealgrid [data-lp-countdown]').forEach(function (el) {
      if (el.dataset.lpCountdownReady === '1') return;
      el.dataset.lpCountdownReady = '1';
      initCountdown(el);
    });
  }
  bootDealgrid();
  document.addEventListener('shopify:section:load', function (e) { bootDealgrid(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-campaign-hero-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nodes = document.querySelectorAll('.lp-campaign-hero-split [data-lp-countdown]');
    if (!nodes.length) return;

    function pad(n) {
      n = Math.max(0, Math.floor(n));
      return n < 10 ? '0' + n : String(n);
    }

    function parseEnd(value) {
      if (!value) return null;
      var v = String(value).trim();
      if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(v)) {
        v = v.replace(' ', 'T');
      }
      var t = Date.parse(v);
      return isNaN(t) ? null : t;
    }

    function tick(node, endTs) {
      var diff = endTs - Date.now();
      var done = diff <= 0;
      var totalSec = Math.max(0, Math.floor(diff / 1000));
      var days = Math.floor(totalSec / 86400);
      var hours = Math.floor((totalSec % 86400) / 3600);
      var minutes = Math.floor((totalSec % 3600) / 60);
      var seconds = totalSec % 60;

      var d = node.querySelector('[data-days]');
      var h = node.querySelector('[data-hours]');
      var m = node.querySelector('[data-minutes]');
      var s = node.querySelector('[data-seconds]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);

      if (done) {
        node.setAttribute('data-ended', 'true');
      }
      return done;
    }

    nodes.forEach(function (node) {
      var endTs = parseEnd(node.getAttribute('data-end-at'));
      if (!endTs) return;
      var done = tick(node, endTs);
      if (done) return;
      var iv = setInterval(function () {
        if (tick(node, endTs)) {
          clearInterval(iv);
        }
      }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-campaign-ribbon-nino"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    n = Math.max(0, Math.floor(n));
    return n < 10 ? '0' + n : '' + n;
  }

  function parseEnd(raw) {
    if (!raw) return NaN;
    var v = String(raw).trim().replace(' ', 'T');
    var ms = Date.parse(v);
    if (isNaN(ms)) {
      ms = new Date(raw).getTime();
    }
    return ms;
  }

  function initCountdown(el) {
    var endMs = parseEnd(el.getAttribute('data-end-at'));
    if (isNaN(endMs)) return;

    var daysEl = el.querySelector('[data-lp-countdown-days]');
    var hoursEl = el.querySelector('[data-lp-countdown-hours]');
    var minutesEl = el.querySelector('[data-lp-countdown-minutes]');
    var secondsEl = el.querySelector('[data-lp-countdown-seconds]');

    function tick() {
      var diff = Math.max(0, endMs - Date.now());
      var total = Math.floor(diff / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      if (daysEl) daysEl.textContent = pad(d);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);

      if (diff <= 0 && el._lpCrnTimer) {
        clearInterval(el._lpCrnTimer);
        el._lpCrnTimer = null;
        el.classList.add('lp-campaign-ribbon-nino__timer--ended');
      }
    }

    if (el._lpCrnTimer) clearInterval(el._lpCrnTimer);
    tick();
    el._lpCrnTimer = setInterval(tick, 1000);
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('.lp-campaign-ribbon-nino [data-lp-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-cat-rail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.lp-cat-rail').forEach(function (section) {
      var rail = section.querySelector('[data-cr-rail]');
      var nav = section.querySelector('[data-cr-nav]');
      var prevBtn = section.querySelector('[data-cr-prev]');
      var nextBtn = section.querySelector('[data-cr-next]');
      if (!rail || !nav || !prevBtn || !nextBtn) return;

      var track = rail.querySelector('.lp-cat-rail__track');
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var behavior = prefersReducedMotion ? 'auto' : 'smooth';

      function getStep() {
        var cell = rail.querySelector('.lp-cat-rail__cell');
        if (!cell) return rail.clientWidth * 0.8;
        var rect = cell.getBoundingClientRect();
        return rect.width + 16;
      }

      function scrollByDir(dir) {
        var step = getStep();
        rail.scrollBy({ left: dir * step, behavior: behavior });
      }

      function updateNavState() {
        // Measure the TRACK's scrollWidth (real content), not the rail's.
        // Rail scrollWidth includes its padding-left used to align with the
        // page container, which inflates the value and breaks the fits check.
        var contentWidth = track ? track.scrollWidth : rail.scrollWidth;
        var fits = contentWidth <= rail.clientWidth + 1;
        nav.hidden = fits;
        rail.classList.toggle('lp-cat-rail__rail--centered', fits);
        if (fits) return;
        var atStart = rail.scrollLeft <= 1;
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
      }

      prevBtn.addEventListener('click', function () { scrollByDir(-1); });
      nextBtn.addEventListener('click', function () { scrollByDir(1); });

      var ticking = false;
      rail.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateNavState();
          ticking = false;
        });
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateNavState, 150);
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateNavState).observe(rail);
      }

      updateNavState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-cat-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCats(root) {
    if (root._catsInit) return;
    root._catsInit = true;

    var isC = root.classList.contains('lp-cats--c');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cats-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cats-panel]'));
    if (!tabs.length) return;

    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p, k) {
        p.classList.toggle('is-active', k === i);
      });
    }

    tabs.forEach(function (t, i) {
      t.tabIndex = i === 0 ? 0 : -1;
      t.addEventListener('click', function () { select(i); });
      if (isC) t.addEventListener('mouseenter', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });

    var prev = root.querySelector('[data-cats-prev]');
    var next = root.querySelector('[data-cats-next]');
    function activeRail() { return root.querySelector('.lp-cats__rail.is-active'); }
    function step(rail) {
      var c = rail && rail.querySelector('.lp-cats__cell');
      return c ? (c.getBoundingClientRect().width + 16) * 2 : 480;
    }
    if (prev) prev.addEventListener('click', function () { var r = activeRail(); if (r) r.scrollBy({ left: -step(r), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { var r = activeRail(); if (r) r.scrollBy({ left: step(r), behavior: 'smooth' }); });
  }

  function boot() { document.querySelectorAll('[data-cats]').forEach(initCats); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-evt-announce-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function parseDate(input) {
    if (!input) return null;
    // Accept "YYYY-MM-DD HH:MM" or full ISO. Replace space with T for Safari.
    var normalized = String(input).trim().replace(' ', 'T');
    var d = new Date(normalized);
    return isNaN(d.getTime()) ? null : d;
  }

  function formatRemaining(ms) {
    if (ms <= 0) return '';
    var totalMinutes = Math.floor(ms / 60000);
    var days = Math.floor(totalMinutes / (60 * 24));
    var hours = Math.floor((totalMinutes - days * 60 * 24) / 60);
    var minutes = totalMinutes - days * 60 * 24 - hours * 60;
    var parts = [];
    if (days > 0) parts.push(days + 'd');
    if (days > 0 || hours > 0) parts.push(hours + 'h');
    parts.push(minutes + 'm');
    return parts.join(' ');
  }

  function init(bar) {
    if (!bar || bar.dataset.lpAnnounceInit === '1') return;
    bar.dataset.lpAnnounceInit = '1';

    var storageKey = bar.getAttribute('data-storage-key') || '';
    var persistenceDays = parseInt(bar.getAttribute('data-persistence-days'), 10);
    if (isNaN(persistenceDays) || persistenceDays < 1) persistenceDays = 7;

    var endAt = parseDate(bar.getAttribute('data-end-at'));
    var autoHideAt = parseDate(bar.getAttribute('data-auto-hide-at'));
    var now = new Date();

    // Auto-hide cutoff
    if (autoHideAt && now > autoHideAt) {
      bar.hidden = true;
      return;
    }

    // Persisted dismissal
    try {
      if (storageKey && window.localStorage) {
        var raw = window.localStorage.getItem(storageKey);
        if (raw) {
          var dismissedAt = parseInt(raw, 10);
          if (!isNaN(dismissedAt)) {
            var elapsedDays = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
            if (elapsedDays < persistenceDays) {
              bar.hidden = true;
              return;
            }
            // Stale dismissal — clean up
            window.localStorage.removeItem(storageKey);
          }
        }
      }
    } catch (e) { /* localStorage unavailable; continue */ }

    // Close button
    var closeBtn = bar.querySelector('[data-lp-announce-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        try {
          if (storageKey && window.localStorage) {
            window.localStorage.setItem(storageKey, String(Date.now()));
          }
        } catch (e) { /* ignore */ }
        bar.hidden = true;
      });
    }

    // Countdown
    var sub = bar.querySelector('[data-lp-announce-countdown]');
    if (sub && endAt) {
      // Preserve the rendered Liquid label as prefix
      var prefix = sub.textContent.trim();

      var tick = function () {
        var diff = endAt.getTime() - Date.now();
        if (diff <= 0) {
          // Countdown expired — hide whole bar
          bar.hidden = true;
          return;
        }
        var remaining = formatRemaining(diff);
        sub.textContent = (prefix ? prefix + ' ' : '') + remaining;
      };

      tick();
      // Update every 30s — minute precision is plenty
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var interval = reduceMotion ? 60000 : 30000;
      setInterval(tick, interval);
    }
  }

  function boot() {
    document.querySelectorAll('[data-lp-announce]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor: re-init on section load/render
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-evt-calendar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nodes = document.querySelectorAll('[data-lp-countdown]');
    if (!nodes.length) return;

    function pad(n) {
      n = Math.max(0, Math.floor(n));
      return n < 10 ? '0' + n : String(n);
    }

    function parseEnd(value) {
      if (!value) return null;
      var v = String(value).trim();
      if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(v)) {
        v = v.replace(' ', 'T');
      }
      var t = Date.parse(v);
      return isNaN(t) ? null : t;
    }

    function tick(node, endTs) {
      var diff = endTs - Date.now();
      var done = diff <= 0;
      var totalSec = Math.max(0, Math.floor(diff / 1000));
      var days = Math.floor(totalSec / 86400);
      var hours = Math.floor((totalSec % 86400) / 3600);
      var minutes = Math.floor((totalSec % 3600) / 60);
      var seconds = totalSec % 60;

      var d = node.querySelector('[data-days]');
      var h = node.querySelector('[data-hours]');
      var m = node.querySelector('[data-minutes]');
      var s = node.querySelector('[data-seconds]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);

      if (done) {
        node.setAttribute('data-ended', 'true');
      }
      return done;
    }

    nodes.forEach(function (node) {
      if (node.dataset.lpCountdownBound === '1') return;
      node.dataset.lpCountdownBound = '1';
      var endTs = parseEnd(node.getAttribute('data-end-at'));
      if (!endTs) return;
      var done = tick(node, endTs);
      if (done) return;
      var iv = setInterval(function () {
        if (tick(node, endTs)) {
          clearInterval(iv);
        }
      }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-evt-hero-navidad"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nodes = document.querySelectorAll('[data-lp-countdown]');
    if (!nodes.length) return;

    function pad(n) {
      n = Math.max(0, Math.floor(n));
      return n < 10 ? '0' + n : String(n);
    }

    function parseEnd(value) {
      if (!value) return null;
      var v = String(value).trim();
      // Accept "YYYY-MM-DD HH:MM" by normalizing to ISO-like with local time.
      if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(v)) {
        v = v.replace(' ', 'T');
      }
      var t = Date.parse(v);
      return isNaN(t) ? null : t;
    }

    function tick(node, endTs) {
      var diff = endTs - Date.now();
      var done = diff <= 0;
      var totalSec = Math.max(0, Math.floor(diff / 1000));
      var days = Math.floor(totalSec / 86400);
      var hours = Math.floor((totalSec % 86400) / 3600);
      var minutes = Math.floor((totalSec % 3600) / 60);
      var seconds = totalSec % 60;

      var d = node.querySelector('[data-days]');
      var h = node.querySelector('[data-hours]');
      var m = node.querySelector('[data-minutes]');
      var s = node.querySelector('[data-seconds]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);

      if (done) {
        node.setAttribute('data-ended', 'true');
      }
      return done;
    }

    nodes.forEach(function (node) {
      var endTs = parseEnd(node.getAttribute('data-end-at'));
      if (!endTs) return;
      var done = tick(node, endTs);
      if (done) return;
      var iv = setInterval(function () {
        if (tick(node, endTs)) {
          clearInterval(iv);
        }
      }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-evt-interstitial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initInterstitial(root) {
      if (!root || root.dataset.lpInterstitialReady === '1') return;
      root.dataset.lpInterstitialReady = '1';

      var trigger = root.getAttribute('data-trigger') || 'time';
      var triggerValue = parseInt(root.getAttribute('data-trigger-value'), 10) || 7;
      var cooldownDays = parseInt(root.getAttribute('data-cooldown-days'), 10) || 14;
      var storageKey = root.getAttribute('data-storage-key') || 'lp-int-default';

      var overlay = root.querySelector('[data-lp-interstitial-overlay]');
      var closeBtn = root.querySelector('[data-lp-interstitial-close]');
      var dismissBtn = root.querySelector('[data-lp-interstitial-dismiss]');
      var form = root.querySelector('form');
      var formWrap = root.querySelector('[data-lp-interstitial-form-wrap]');
      var successEl = root.querySelector('[data-lp-interstitial-success]');

      // Cooldown check via localStorage
      try {
        var stored = localStorage.getItem(storageKey);
        if (stored) {
          var ts = parseInt(stored, 10);
          if (!isNaN(ts)) {
            var diffMs = Date.now() - ts;
            var cooldownMs = cooldownDays * 24 * 60 * 60 * 1000;
            if (diffMs < cooldownMs) return;
          }
        }
      } catch (e) {
        // localStorage unavailable — proceed without cooldown
      }

      var opened = false;
      var triggered = false;

      function open() {
        if (opened) return;
        opened = true;
        root.hidden = false;
        root.removeAttribute('aria-hidden');
        // Force reflow for transition
        // eslint-disable-next-line no-unused-expressions
        root.offsetHeight;
        root.setAttribute('data-open', '');
        document.body.classList.add('lp-evt-interstitial-open');
        // Focus management
        var focusTarget = root.querySelector('input[type="email"]') || closeBtn;
        if (focusTarget) {
          try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); }
        }
      }

      function persistDismissed() {
        try {
          localStorage.setItem(storageKey, String(Date.now()));
        } catch (e) {
          // ignore
        }
      }

      function close() {
        if (!opened) return;
        opened = false;
        root.removeAttribute('data-open');
        root.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('lp-evt-interstitial-open');
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var delay = reduceMotion ? 0 : 220;
        setTimeout(function () {
          if (!opened) root.hidden = true;
        }, delay);
        persistDismissed();
      }

      // Bind close handlers
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (overlay) overlay.addEventListener('click', close);
      if (dismissBtn) dismissBtn.addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && opened) close();
      });

      // Trigger setup
      function fire() {
        if (triggered) return;
        triggered = true;
        cleanupTriggers();
        open();
      }

      var cleanupFns = [];
      function cleanupTriggers() {
        cleanupFns.forEach(function (fn) { try { fn(); } catch (e) {} });
        cleanupFns = [];
      }

      if (trigger === 'time') {
        var t = setTimeout(fire, Math.max(1, triggerValue) * 1000);
        cleanupFns.push(function () { clearTimeout(t); });
      } else if (trigger === 'scroll') {
        var onScroll = function () {
          var doc = document.documentElement;
          var total = doc.scrollHeight - doc.clientHeight;
          if (total <= 0) return;
          var pct = (window.scrollY || doc.scrollTop) / total * 100;
          if (pct >= triggerValue) fire();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        cleanupFns.push(function () { window.removeEventListener('scroll', onScroll); });
      } else if (trigger === 'exit') {
        var onLeave = function (e) {
          if (e.clientY <= 0) fire();
        };
        document.addEventListener('mouseleave', onLeave);
        cleanupFns.push(function () { document.removeEventListener('mouseleave', onLeave); });
      }

      // Form success state
      if (form && successEl) {
        // If success was rendered server-side (form.posted_successfully?), open immediately
        if (!successEl.hasAttribute('hidden')) {
          if (formWrap) formWrap.hidden = true;
          // Show modal so user can see the message
          open();
        }
        form.addEventListener('submit', function () {
          // Persist immediately so cooldown applies even on submit
          persistDismissed();
        });
      }
    }

    function init() {
      document.querySelectorAll('[data-lp-interstitial]').forEach(initInterstitial);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-lp-interstitial]');
      if (root) initInterstitial(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hot-sale"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    n = Math.max(0, Math.floor(n));
    return n < 10 ? '0' + n : '' + n;
  }

  function initCountdown(el) {
    var endTs = parseInt(el.getAttribute('data-end'), 10);
    if (!endTs || isNaN(endTs)) return;
    var endMs = endTs * 1000;

    var digits = {};
    el.querySelectorAll('.lp-hot-sale__timer-digit').forEach(function (d) {
      var key = d.getAttribute('data-key');
      if (key) digits[key] = d;
    });

    var section = el.closest('[data-lp-hot-sale]');
    var ended = false;

    function tick() {
      var nowMs = Date.now();
      var diff = Math.max(0, endMs - nowMs);

      if (diff <= 0 && !ended) {
        ended = true;
        if (digits.days) digits.days.textContent = '00';
        if (digits.hours) digits.hours.textContent = '00';
        if (digits.minutes) digits.minutes.textContent = '00';
        if (digits.seconds) digits.seconds.textContent = '00';
        clearInterval(intervalId);
        if (section) {
          section.dispatchEvent(new CustomEvent('lp-countdown:ended', { bubbles: true }));
        }
        return;
      }

      var totalSec = Math.floor(diff / 1000);
      var days = Math.floor(totalSec / 86400);
      var hours = Math.floor((totalSec % 86400) / 3600);
      var minutes = Math.floor((totalSec % 3600) / 60);
      var seconds = totalSec % 60;

      // If days digit not rendered, roll days into hours
      if (!digits.days) {
        hours = hours + days * 24;
      } else {
        digits.days.textContent = pad(days);
      }
      if (digits.hours) digits.hours.textContent = pad(hours);
      if (digits.minutes) digits.minutes.textContent = pad(minutes);
      if (digits.seconds) digits.seconds.textContent = pad(seconds);
    }

    tick();
    var intervalId = setInterval(tick, 1000);
  }

  function bootHotSale(scope) {
    (scope || document).querySelectorAll('.lp-hot-sale [data-lp-countdown]').forEach(function (el) {
      if (el.dataset.lpCountdownReady === '1') return;
      el.dataset.lpCountdownReady = '1';
      initCountdown(el);
    });
  }
  bootHotSale();
  document.addEventListener('shopify:section:load', function (e) { bootHotSale(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-mega-deal"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseEnd(value) {
    if (!value) return null;
    var v = String(value).trim();
    // Accept "YYYY-MM-DD HH:MM" or ISO. Replace space with 'T' so Safari parses it.
    if (v.indexOf('T') === -1 && v.indexOf(' ') !== -1) {
      v = v.replace(' ', 'T');
    }
    var d = new Date(v);
    if (isNaN(d.getTime())) return null;
    return d;
  }

  function init(root) {
    var endAt = parseEnd(root.getAttribute('data-end-at'));
    if (!endAt) return;

    var section = root.closest('.lp-mega-deal');
    var nums = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };

    var timerId = null;

    function tick() {
      var now = new Date();
      var diff = Math.max(0, Math.floor((endAt.getTime() - now.getTime()) / 1000));
      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;

      if (nums.days) nums.days.textContent = pad(d);
      if (nums.hours) nums.hours.textContent = pad(h);
      if (nums.minutes) nums.minutes.textContent = pad(m);
      if (nums.seconds) nums.seconds.textContent = pad(s);

      if (diff <= 0) {
        if (timerId) clearInterval(timerId);
        if (section) section.classList.add('lp-mega-deal--ended');
        root.dispatchEvent(new CustomEvent('lp-countdown:ended', { bubbles: true }));
      }
    }

    tick();
    timerId = setInterval(tick, 1000);
  }

  function bootMega(scope) {
    (scope || document).querySelectorAll('.lp-mega-deal [data-lp-countdown]').forEach(function (el) {
      if (el.dataset.lpCountdownReady === '1') return;
      el.dataset.lpCountdownReady = '1';
      init(el);
    });
  }
  bootMega();
  document.addEventListener('shopify:section:load', function (e) { bootMega(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPopup(root) {
    if (root._lppInit) return;
    root._lppInit = true;

    var dialog = root.querySelector('.lp-popup__dialog');
    var closers = root.querySelectorAll('[data-lp-popup-close]');
    var design = !!(window.Shopify && window.Shopify.designMode);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Modo esquina = tarjeta NO bloqueante: no traba el scroll ni roba el foco,
       la pagina se sigue navegando detras. Solo el modo centrado (modal) bloquea. */
    var isCorner = root.classList.contains('lp-popup--corner');

    var cfg = {
      trigger: root.getAttribute('data-trigger') || 'delay',
      delay: parseInt(root.getAttribute('data-delay'), 10) || 4,
      scroll: parseInt(root.getAttribute('data-scroll'), 10) || 50,
      freq: root.getAttribute('data-frequency') || 'days',
      days: parseInt(root.getAttribute('data-days'), 10) || 7,
      key: root.getAttribute('data-storage-key') || 'lp-popup'
    };

    var lastFocus = null;
    var shown = false;

    function seen() {
      if (design) return false;
      try {
        if (cfg.freq === 'always') return false;
        if (cfg.freq === 'session') return sessionStorage.getItem(cfg.key) === '1';
        var t = parseInt(localStorage.getItem(cfg.key), 10);
        if (!t) return false;
        return (Date.now() - t) < cfg.days * 86400000;
      } catch (e) {
        return false;
      }
    }

    function markSeen() {
      if (design) return;
      try {
        if (cfg.freq === 'session') sessionStorage.setItem(cfg.key, '1');
        else if (cfg.freq === 'days') localStorage.setItem(cfg.key, String(Date.now()));
      } catch (e) {}
    }

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (isCorner || e.key !== 'Tab') return;
      var f = dialog.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      if (shown) return;
      shown = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-open');
      markSeen();
      if (!isCorner) {
        document.body.style.overflow = 'hidden';
        var f = dialog.querySelector('.lp-popup__close') || dialog;
        if (f && f.focus) f.focus();
      }
      document.addEventListener('keydown', onKey, true);
    }

    function close() {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey, true);
      if (reduce) {
        root.hidden = true;
      } else {
        var done = function () { root.hidden = true; root.removeEventListener('transitionend', done); };
        root.addEventListener('transitionend', done);
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    Array.prototype.forEach.call(closers, function (c) {
      c.addEventListener('click', close);
    });

    if (seen()) return;
    if (design) { open(); return; }

    if (cfg.trigger === 'scroll') {
      var onScroll = function () {
        var h = document.documentElement;
        var max = h.scrollHeight - h.clientHeight;
        var pct = max > 0 ? (h.scrollTop / max) * 100 : 100;
        if (pct >= cfg.scroll) { window.removeEventListener('scroll', onScroll); open(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    } else if (cfg.trigger === 'exit') {
      var onExit = function (e) {
        if (e.clientY <= 0) { document.removeEventListener('mouseout', onExit); open(); }
      };
      document.addEventListener('mouseout', onExit);
      /* Fallback táctil (sin exit-intent en mobile): abrir tras 12 s. */
      setTimeout(function () { if (!shown) open(); }, 12000);
    } else {
      setTimeout(open, cfg.delay * 1000);
    }
  }

  function boot() {
    document.querySelectorAll('[data-lp-popup]').forEach(initPopup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-rubro-editorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRedit(root) {
    if (root._reditInit) return;
    root._reditInit = true;

    var rail = root.querySelector('[data-redit-rail]');
    var prev = root.querySelector('[data-redit-prev]');
    var next = root.querySelector('[data-redit-next]');
    if (!rail) return;

    function step() {
      var card = rail.querySelector('.lp-redit__rail-item');
      if (card) return card.getBoundingClientRect().width + 16;
      return rail.clientWidth * 0.8;
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    document.querySelectorAll('[data-redit]').forEach(initRedit);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-season-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    n = Math.max(0, Math.floor(n));
    return n < 10 ? '0' + n : String(n);
  }

  function initCountdown(el) {
    var endRaw = el.getAttribute('data-end-at');
    if (!endRaw) return;

    // Accept "YYYY-MM-DD HH:MM" or ISO-style strings. Replace space with T for Safari.
    var normalized = endRaw.trim().replace(' ', 'T');
    var endMs = Date.parse(normalized);
    if (isNaN(endMs)) {
      // Fallback: try Date constructor on the raw value.
      endMs = new Date(endRaw).getTime();
    }
    if (isNaN(endMs)) return;

    var daysEl = el.querySelector('[data-lp-countdown-days]');
    var hoursEl = el.querySelector('[data-lp-countdown-hours]');
    var minutesEl = el.querySelector('[data-lp-countdown-minutes]');
    var secondsEl = el.querySelector('[data-lp-countdown-seconds]');

    function tick() {
      var now = Date.now();
      var diff = Math.max(0, endMs - now);

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);

      if (diff <= 0) {
        clearInterval(el._lpCountdownTimer);
        el._lpCountdownTimer = null;
        el.classList.add('lp-season-countdown__timer--ended');
      }
    }

    if (el._lpCountdownTimer) {
      clearInterval(el._lpCountdownTimer);
    }
    tick();
    el._lpCountdownTimer = setInterval(tick, 1000);
  }

  function initAll(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('[data-lp-countdown]');
    nodes.forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when the theme editor swaps sections.
  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-si-club"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.lp-si-club').forEach(function (root) {
      var form = root.querySelector('form');
      var success = root.querySelector('[data-lp-si-club-success]');
      if (!form || !success) return;

      // If Shopify rendered with `?customer_posted=true`, the server-side
      // `form.posted_successfully?` branch already removed [hidden] and
      // added .is-visible — nothing to do.
      if (!success.hasAttribute('hidden')) {
        try { success.focus({ preventScroll: false }); } catch (e) {}
        return;
      }

      // Light-touch enhancement: when the form is being submitted, briefly
      // disable the CTA so merchants don't double-submit. Shopify reloads
      // the page so we don't need AJAX.
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (!btn) return;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-si-coupon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SUCCESS_MS = 1600;

    function fallbackCopy(text) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        ta.style.left = '-1000px';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok;
      } catch (e) {
        return false;
      }
    }

    function copy(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).then(function () { return true; }).catch(function () {
          return fallbackCopy(text);
        });
      }
      return Promise.resolve(fallbackCopy(text));
    }

    function bind(btn) {
      if (!btn || btn.__lpCouponBound) return;
      btn.__lpCouponBound = true;

      var textEl = btn.querySelector('.lp-si-coupon__btn-text');
      var originalLabel = btn.getAttribute('data-label') || (textEl ? textEl.textContent : '');
      var copiedLabel = btn.getAttribute('data-copied') || '¡Copiado!';
      var code = btn.getAttribute('data-lp-copy') || '';

      btn.addEventListener('click', function () {
        if (!code) return;
        Promise.resolve(copy(code)).then(function (ok) {
          if (!ok) return;
          btn.classList.add('lp-si-coupon__btn--success');
          if (textEl) textEl.textContent = copiedLabel;
          if (btn.__lpResetTimer) clearTimeout(btn.__lpResetTimer);
          btn.__lpResetTimer = setTimeout(function () {
            btn.classList.remove('lp-si-coupon__btn--success');
            if (textEl) textEl.textContent = originalLabel;
          }, SUCCESS_MS);
        });
      });
    }

    document.querySelectorAll('.lp-si-coupon [data-lp-copy]').forEach(bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-si-flash-sale"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    n = Math.max(0, Math.floor(n));
    return n < 10 ? '0' + n : String(n);
  }

  function parseEnd(el) {
    var raw = el.getAttribute('data-end') || el.getAttribute('data-end-at') || '';
    if (!raw) return NaN;
    // Numeric epoch seconds (Liquid `date: '%s'`)
    if (/^\d+$/.test(raw.trim())) {
      return parseInt(raw.trim(), 10) * 1000;
    }
    // Accept "YYYY-MM-DD HH:MM" or ISO. Replace space with T for Safari.
    var normalized = raw.trim().replace(' ', 'T');
    var ms = Date.parse(normalized);
    if (isNaN(ms)) ms = new Date(raw).getTime();
    return ms;
  }

  function initCountdown(el) {
    var endMs = parseEnd(el);
    if (isNaN(endMs)) return;

    var withDaysAttr = (el.getAttribute('data-with-days') || 'true').toLowerCase();
    var withDays = withDaysAttr !== 'false' && withDaysAttr !== '0';

    var hoursEl = el.querySelector('[data-key="hours"]');
    var minutesEl = el.querySelector('[data-key="minutes"]');
    var secondsEl = el.querySelector('[data-key="seconds"]');
    var daysEl = el.querySelector('[data-key="days"]');

    function tick() {
      var diff = Math.max(0, endMs - Date.now());
      var totalSeconds = Math.floor(diff / 1000);

      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (!withDays) {
        // Roll days into hours when the variant hides the days unit.
        hours = Math.floor(totalSeconds / 3600);
      }

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);

      if (diff <= 0 && el._lpCountdownTimer) {
        clearInterval(el._lpCountdownTimer);
        el._lpCountdownTimer = null;
        el.classList.add('lp-si-flash-sale__timer--ended');
      }
    }

    if (el._lpCountdownTimer) clearInterval(el._lpCountdownTimer);
    tick();
    el._lpCountdownTimer = setInterval(tick, 1000);
  }

  function initAll(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.lp-si-flash-sale [data-lp-countdown]');
    nodes.forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-si-freeship-progress"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-lp-freeship]');
    if (!roots.length) return;

    function parseTemplate(tpl, parts) {
      return String(tpl || '')
        .replace(/\{falta\}/g, parts.falta)
        .replace(/\{actual\}/g, parts.actual)
        .replace(/\{goal\}/g, parts.goal);
    }

    function fmtMoney(cents, currency) {
      var major = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat('es-UY', {
          style: 'currency',
          currency: currency || 'UYU',
          maximumFractionDigits: 0
        }).format(major);
      } catch (e) {
        return '$' + Math.round(major);
      }
    }

    function applyState(root, cart) {
      var threshold = parseFloat(root.getAttribute('data-threshold')) || 0;
      if (threshold <= 0) return;

      var thresholdCents = Math.round(threshold * 100);
      var totalCents = Math.max(0, Number(cart && cart.total_price) || 0);
      var itemCount = Math.max(0, Number(cart && cart.item_count) || 0);
      var hideEmpty = root.getAttribute('data-hide-empty') === 'true';
      var currency = root.getAttribute('data-currency-code') || 'UYU';

      if (hideEmpty && itemCount === 0) {
        root.hidden = true;
        return;
      }
      root.hidden = false;

      var pct = thresholdCents > 0 ? (totalCents / thresholdCents) * 100 : 0;
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;

      var reached = totalCents >= thresholdCents;
      var falta = Math.max(0, thresholdCents - totalCents);

      var parts = {
        falta: fmtMoney(falta, currency),
        actual: fmtMoney(totalCents, currency),
        goal: fmtMoney(thresholdCents, currency)
      };

      var headline = root.querySelector('[data-fs-headline]');
      var fill = root.querySelector('[data-fs-fill]');
      var bar = root.querySelector('[data-fs-bar]');
      var status = root.querySelector('[data-fs-status]');

      if (headline) {
        if (reached) {
          headline.textContent = root.getAttribute('data-reached-message') || '';
          root.classList.add('lp-si-freeship-progress--reached');
        } else {
          headline.textContent = parseTemplate(root.getAttribute('data-headline-template'), parts);
          root.classList.remove('lp-si-freeship-progress--reached');
        }
      }

      if (fill) fill.style.width = pct + '%';
      if (bar) bar.setAttribute('aria-valuenow', String(Math.round(pct)));

      if (status) {
        var tpl = root.getAttribute('data-status-template') || '';
        status.textContent = tpl
          .replace(/__ACTUAL__/g, parts.actual)
          .replace(/__GOAL__/g, parts.goal);
      }
    }

    function applyAll(cart) {
      roots.forEach(function (root) { applyState(root, cart); });
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }

    function refreshFromServer() {
      fetchCart().then(function (cart) {
        if (cart) applyAll(cart);
      });
    }

    // Subscribe to Dawn's pubsub cart-update event.
    function trySubscribe() {
      if (typeof window.subscribe !== 'function') return false;
      if (!window.PUB_SUB_EVENTS || !window.PUB_SUB_EVENTS.cartUpdate) return false;
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.total_price === 'number') {
          applyAll(event.cartData);
        } else {
          refreshFromServer();
        }
      });
      return true;
    }

    if (!trySubscribe()) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', trySubscribe);
      }
      setTimeout(trySubscribe, 200);
    }

    // Belt-and-suspenders: re-sync after any cart line removal click.
    document.body.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-remove-button')) {
        setTimeout(refreshFromServer, 300);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-si-newsletter-coupon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nodes = document.querySelectorAll('[data-lp-countdown]');
    if (!nodes.length) return;

    function pad(n) {
      n = Math.max(0, Math.floor(n));
      return n < 10 ? '0' + n : String(n);
    }

    function parseEnd(value) {
      if (!value) return null;
      var v = String(value).trim();
      if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(v)) {
        v = v.replace(' ', 'T');
      }
      var t = Date.parse(v);
      return isNaN(t) ? null : t;
    }

    function tick(node, endTs) {
      var diff = endTs - Date.now();
      var done = diff <= 0;
      var totalSec = Math.max(0, Math.floor(diff / 1000));
      var days = Math.floor(totalSec / 86400);
      var hours = Math.floor((totalSec % 86400) / 3600);
      var minutes = Math.floor((totalSec % 3600) / 60);
      var seconds = totalSec % 60;

      var d = node.querySelector('[data-days]');
      var h = node.querySelector('[data-hours]');
      var m = node.querySelector('[data-minutes]');
      var s = node.querySelector('[data-seconds]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);

      if (done) {
        node.setAttribute('data-ended', 'true');
      }
      return done;
    }

    nodes.forEach(function (node) {
      if (node.dataset.lpCountdownInit === '1') return;
      var endTs = parseEnd(node.getAttribute('data-end-at'));
      if (!endTs) return;
      node.dataset.lpCountdownInit = '1';
      var done = tick(node, endTs);
      if (done) return;
      var iv = setInterval(function () {
        if (tick(node, endTs)) {
          clearInterval(iv);
        }
      }, 1000);
    });

    // On a successful form post, scroll the success message into view.
    document.querySelectorAll('.lp-si-newsletter-coupon [data-lp-nc-success]').forEach(function (el) {
      try {
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } catch (e) {
        el.scrollIntoView();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-si-weekend"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    n = Math.max(0, Math.floor(n));
    return n < 10 ? '0' + n : String(n);
  }

  function initCountdown(el) {
    var endRaw = el.getAttribute('data-end-at');
    if (!endRaw) return;

    var normalized = endRaw.trim().replace(' ', 'T');
    var endMs = Date.parse(normalized);
    if (isNaN(endMs)) {
      endMs = new Date(endRaw).getTime();
    }
    if (isNaN(endMs)) return;

    var daysEl = el.querySelector('[data-lp-countdown-days]');
    var hoursEl = el.querySelector('[data-lp-countdown-hours]');
    var minutesEl = el.querySelector('[data-lp-countdown-minutes]');
    var secondsEl = el.querySelector('[data-lp-countdown-seconds]');

    function tick() {
      var now = Date.now();
      var diff = Math.max(0, endMs - now);

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);

      if (diff <= 0) {
        clearInterval(el._lpWkTimer);
        el._lpWkTimer = null;
        el.classList.add('lp-si-weekend__timer--ended');
      }
    }

    if (el._lpWkTimer) {
      clearInterval(el._lpWkTimer);
    }
    tick();
    el._lpWkTimer = setInterval(tick, 1000);
  }

  function initAll(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.lp-si-weekend [data-lp-countdown]');
    nodes.forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-sv-typelist"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DESKTOP_QUERY = '(min-width: 990px)';
  var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  document.querySelectorAll('.lp-sv-typelist').forEach(function (section) {
    var list = section.querySelector('[data-tl-list]');
    var photo = section.querySelector('[data-tl-photo]');
    var addBtn = section.querySelector('[data-tl-add]');
    var addLabel = section.querySelector('[data-tl-add-label]');
    if (!list) return;

    var rows = section.querySelectorAll('[data-tl-row]');
    if (!rows.length) return;

    var desktopMQ = window.matchMedia(DESKTOP_QUERY);
    var reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches;

    function applyProduct(row) {
      if (!row) return;
      var imgUrl = row.getAttribute('data-image');
      var imgAlt = row.getAttribute('data-image-alt') || '';
      var variantId = row.getAttribute('data-variant-id');
      var productId = row.getAttribute('data-product-id');
      var productHandle = row.getAttribute('data-product-handle');
      var available = row.getAttribute('data-available') === '1';

      if (photo && imgUrl) {
        var newHtml =
          '<img src="' + imgUrl + '" alt="' + imgAlt.replace(/"/g, '&quot;') + '"' +
          ' loading="lazy" decoding="async" width="720" height="900">';
        photo.innerHTML = newHtml;
      }

      if (addBtn) {
        if (variantId) addBtn.setAttribute('data-variant-id', variantId);
        if (productId) addBtn.setAttribute('data-product-id', productId);
        if (productHandle) addBtn.setAttribute('data-product-handle', productHandle);
        if (available) {
          addBtn.removeAttribute('disabled');
          addBtn.removeAttribute('aria-disabled');
        } else {
          addBtn.setAttribute('disabled', '');
          addBtn.setAttribute('aria-disabled', 'true');
        }
      }

      // Toggle active state
      rows.forEach(function (r) { r.classList.remove('is-active'); });
      row.classList.add('is-active');
    }

    function bindDesktop() {
      rows.forEach(function (row) {
        row.addEventListener('mouseenter', function () {
          if (desktopMQ.matches) applyProduct(row);
        });
        row.addEventListener('focusin', function () {
          if (desktopMQ.matches) applyProduct(row);
        });
      });
    }

    function bindMobile() {
      rows.forEach(function (row) {
        row.addEventListener('click', function (e) {
          if (desktopMQ.matches) return;
          // Don't toggle if user clicked the product name link
          if (e.target.closest('a')) return;
          rows.forEach(function (r) {
            if (r !== row) r.classList.remove('is-open');
          });
          row.classList.toggle('is-open');
        });
      });
    }

    bindDesktop();
    bindMobile();

    // Initial: mark first row as active (already reflected in sticky photo)
    if (rows[0]) rows[0].classList.add('is-active');

    // Add-to-cart wiring: dispatch a CustomEvent for the theme cart layer.
    // If a global LP cart helper exists, use it; otherwise post to /cart/add.js
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = addBtn.getAttribute('data-variant-id');
        if (!variantId || addBtn.hasAttribute('disabled')) return;

        var originalLabel = addLabel ? addLabel.textContent : '';
        if (addLabel) addLabel.textContent = addLabel.getAttribute('data-busy') || '...';
        addBtn.setAttribute('disabled', '');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        }).then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        }).then(function (res) {
          if (addLabel) addLabel.textContent = originalLabel;
          addBtn.removeAttribute('disabled');
          if (res.ok) {
            document.dispatchEvent(new CustomEvent('lp:cart:added', { detail: res.data }));
          }
        }).catch(function () {
          if (addLabel) addLabel.textContent = originalLabel;
          addBtn.removeAttribute('disabled');
        });
      });
    }

    // Suppress hover effect on reduced motion (CSS already guards transitions,
    // but the hover-opacity rule still applies; we don't override it here —
    // CSS handles the prefers-reduced-motion guard).
    if (reducedMotion) {
      // No-op; CSS guards opacity transition. Hover state is instant.
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-section-id]');

    sections.forEach(function (section) {
      if (!section.classList.contains('lp-main-page')) return;

      var prose = section.querySelector('[data-lp-prose]');
      var tocList = section.querySelector('[data-lp-toc-list]');
      if (!prose || !tocList) return;

      var headings = prose.querySelectorAll('h2, h3');
      if (!headings.length) return;

      var slug = function (text) {
        return String(text || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '')
          .slice(0, 64);
      };

      var idCounts = {};
      var items = [];

      headings.forEach(function (h) {
        var text = (h.textContent || '').trim();
        if (!text) return;
        var id = h.id;
        if (!id) {
          var base = slug(text) || 'section';
          idCounts[base] = (idCounts[base] || 0) + 1;
          id = idCounts[base] === 1 ? base : base + '-' + idCounts[base];
          h.id = id;
        }
        items.push({ id: id, text: text, level: h.tagName === 'H2' ? 2 : 3 });
      });

      if (!items.length) return;

      var emptyLi = tocList.querySelector('[data-lp-toc-empty]');
      if (emptyLi) emptyLi.remove();

      var frag = document.createDocumentFragment();
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'lp-main-page__toc-item';
        var a = document.createElement('a');
        a.href = '#' + item.id;
        a.className = 'lp-main-page__toc-link' + (item.level === 3 ? ' lp-main-page__toc-link--h3' : '');
        a.textContent = item.text;
        a.setAttribute('data-lp-toc-target', item.id);
        li.appendChild(a);
        frag.appendChild(li);
      });
      tocList.appendChild(frag);

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      tocList.addEventListener('click', function (e) {
        var link = e.target.closest('a[data-lp-toc-target]');
        if (!link) return;
        var id = link.getAttribute('data-lp-toc-target');
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        if (history.pushState) {
          history.pushState(null, '', '#' + id);
        }
      });

      if ('IntersectionObserver' in window) {
        var activeId = null;
        var setActive = function (id) {
          if (id === activeId) return;
          activeId = id;
          var links = tocList.querySelectorAll('.lp-main-page__toc-link');
          links.forEach(function (l) {
            if (l.getAttribute('data-lp-toc-target') === id) {
              l.classList.add('is-active');
            } else {
              l.classList.remove('is-active');
            }
          });
        };

        var observed = prose.querySelectorAll('h2, h3');
        var visibleMap = new Map();
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              visibleMap.set(entry.target.id, entry.boundingClientRect.top);
            } else {
              visibleMap.delete(entry.target.id);
            }
          });
          if (visibleMap.size) {
            var topMost = null;
            var topY = Infinity;
            visibleMap.forEach(function (y, id) {
              if (y < topY) { topY = y; topMost = id; }
            });
            if (topMost) setActive(topMost);
          }
        }, { rootMargin: '-96px 0px -60% 0px', threshold: 0 });

        observed.forEach(function (h) { observer.observe(h); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
